import React from 'react';

type DragContextProps = {
  reorder: (dataItem: any) => void;
  dragStart: (dataItem: any) => void;
};

export const DragContext = React.createContext<DragContextProps>({
  reorder: () => {},
  dragStart: () => {}
});
